var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 71,
    viewBox: "0 0 61 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.495239,
    width: 60.4541,
    height: 69.6047,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_96",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 71
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.495239,
    width: 60.4541,
    height: 69.6047,
    fill: "url(#pattern1)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_96)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.495239,
    width: 60.4541,
    height: 69.6047,
    fill: "#BA291B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_96",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_96",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_96",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAi9JREFUeJzt3cFNA0EQBdG/iADIADLAGdhEAimQAUQAGWEygEzIoLlw4ASLPfI0qnpnu2lZJc9qhbyJJEmScJZj3lxV+yTbMavoQK/LsuwOffPZwEX0DxkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQDc+ewFvtwneZu9xIltkjzNXqJLAG/LsuxnL3FKVTV7hSQeAXgGAGcAcF2uAZ6q6mP2Eid2MXuBpE8Am9kLUHkEwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcB1CeBmWSHJ44g5HSS5OcHn+qsuAWgSA4AzADgDgOvyEzEvg343b9QcDL8B4AwAzgDgDADOAOAMAM4A4AwAzgDgutwJXPvImLsktwPmdOAjY75Z9ciYqtqNmNNBl1vWHgFwBgBnAHBdrgFuq2q74nW/vWbtnA6uZi+Q9AngrtkcDI8AOAOAMwA4A4AzADgDgDMAOAOA63Ij6D3JmodHXyW5HDCng4sk17OXOEpV7WuM3cq/9zBiTgdVtRv02e2P2cMjAM4A4AwArstF4HXVqv+R+ukC8C9zOmhxAdglgOdmczA8AuAMAM4A4AwAzgDgDADOAOAMAM4A4AwAzgDgDADOAOAMAM4A4AwAzgDgDADOAOAMAM4A4AxAkiRJovkElIP2WTkLXHoAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDetails);
export default __webpack_public_path__ + "static/media/order_details.697e18756b0597f1a0dc871032e6b7b9.svg";
export { ForwardRef as ReactComponent };